import flags from "../../../shared/feature-flags.json";

/** A feature the dashboards can hold back from customers: a key of shared/feature-flags.json. */
export type FeatureFlag = keyof typeof flags;

/**
 * Whether customers are offered `flag`'s feature. Every flag is in shared/feature-flags.json, the one list of both
 * dashboards' flags, with since when, what it holds back and why; the Angular dashboard reads the same file
 * (core/service/feature-flags.ts). A held-back feature is hidden through this, never a hard-coded `false`.
 */
export const isFeatureOn = (flag: FeatureFlag): boolean => flags[flag].enabled;
